import { type PaymentMethodsResponse } from '@adyen/adyen-web';

export interface AdyenProviderInitData {
    provider: 'ADYEN';
    paymentMethodsResponse?: PaymentMethodsResponse;
}

export interface StripeProviderInitData {
    provider: 'STRIPE';
    clientSecret?: string;
    providerAccountCode?: string;
    paymentMethodOrder?: string[];
    metadata?: { [key: string]: string };
}

export interface GoCardlessProviderInitData {
    provider: 'GOCARDLESS';
    billingRequestFlowId: string;
}

export interface WorldpayProviderInitData {
    provider: 'WORLDPAY';
    businessKey?: string;
}

export type ProviderInitData =
    | AdyenProviderInitData
    | GoCardlessProviderInitData
    | StripeProviderInitData
    | WorldpayProviderInitData;

export function isAdyenInitData(
    data: ProviderInitData | undefined
): data is AdyenProviderInitData {
    return data?.provider === 'ADYEN';
}

export function isStripeInitData(
    data: ProviderInitData | undefined
): data is StripeProviderInitData {
    return data?.provider === 'STRIPE';
}

export function isGoCardlessInitData(
    data: ProviderInitData | undefined
): data is GoCardlessProviderInitData {
    return data?.provider === 'GOCARDLESS';
}

export function isWorldpayInitData(
    data: ProviderInitData | undefined
): data is WorldpayProviderInitData {
    return data?.provider === 'WORLDPAY';
}
